var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex flex-row gap-2 mb-2" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "influencers.create",
                  expression: "'influencers.create'",
                },
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { 400: true },
                },
              ],
              attrs: { variant: "primary" },
              on: { click: _vm.addNew },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "PlusIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("AddNew"))),
              ]),
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "influencers.approve",
                  expression: "'influencers.approve'",
                },
              ],
              attrs: { variant: "outline-primary" },
              on: { click: _vm.goToApprovals },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "UserCheckIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("influencer.approvals"))),
              ]),
              _vm.pendingCount > 0
                ? _c(
                    "b-badge",
                    { staticClass: "ml-50", attrs: { variant: "warning" } },
                    [_vm._v(_vm._s(_vm.pendingCount))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_name: "influencers",
          order_column: "id",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "name" }, [
                  _vm._v(_vm._s(_vm.$t("influencer.name"))),
                ]),
                _c("vs-th", { key: "networks" }, [
                  _vm._v(_vm._s(_vm.$t("influencer.networks"))),
                ]),
                _c("vs-th", { key: "level" }, [
                  _vm._v(_vm._s(_vm.$t("influencer.level"))),
                ]),
                _c(
                  "vs-th",
                  { key: "source", attrs: { "sort-key": "source" } },
                  [_vm._v(_vm._s(_vm.$t("influencer.source")))]
                ),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("influencer.status")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _vm._v(_vm._s(tr.id)),
                    ]),
                    _c("vs-td", { key: "name", attrs: { width: "25%" } }, [
                      _c("div", { staticClass: "font-medium" }, [
                        _vm._v(_vm._s(_vm._.get(tr, "name"))),
                      ]),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm._.get(tr, "email"))),
                      ]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "networks", attrs: { width: "25%" } },
                      [
                        !(tr.social_profiles || []).length
                          ? _c("span", { staticClass: "text-muted" }, [
                              _vm._v("—"),
                            ])
                          : _vm._e(),
                        _vm._l(tr.social_profiles || [], function (p) {
                          return _c(
                            "span",
                            { key: p.id, staticClass: "mr-1" },
                            [
                              _c(
                                "vs-chip",
                                {
                                  attrs: { transparent: "", color: "primary" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(p.network_label) +
                                      " @" +
                                      _vm._s(p.handle)
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                    _c("vs-td", { key: "level", attrs: { width: "12%" } }, [
                      _vm._.get(tr, "level.name")
                        ? _c("span", [
                            _vm._v(_vm._s(_vm._.get(tr, "level.name"))),
                          ])
                        : _c("span", { staticClass: "text-muted" }, [
                            _vm._v("—"),
                          ]),
                    ]),
                    _c("vs-td", { key: "source", attrs: { width: "13%" } }, [
                      _vm._v(_vm._s(_vm.formatSource(_vm._.get(tr, "source")))),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "10%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.statusColor(_vm._.get(tr, "status")),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatStatus(_vm._.get(tr, "status"))
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", { attrs: { width: "10%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "influencers.edit",
                                expression: "'influencers.edit'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function ($event) {
                                return props.edit(props.data[indextr].id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "influencers.delete",
                                expression: "'influencers.delete'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function ($event) {
                                return props.destroy(props.data[indextr])
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }